import React, { useState } from "react";
import Navbar from "./components/Ui/Navbar";
import Home from "./components/Ui/Home";
import About from "./components/Ui/About";
import Services from "./components/Ui/Services";
import HappyCostomer from "./components/Ui/HappyCostomer";
import Contact from "./components/Ui/Contact";
import Footer from "./components/Ui/Footer";
import TestRideModal from "./components/TestRideModal";

// Global dark theme styles - Golden Theme
const globalStyles = `
  * { margin: 0; padding: 0; box-sizing: border-box; }
  body {
    background: #050505;
    color: #F5F5F5;
    overflow-x: hidden;
    // cursor: none;
  }

  /* Custom cursor */
  .cursor-dot {
    position: fixed; width: 10px; height: 10px;
    background: #D4AF37; border-radius: 50%;
    pointer-events: none; z-index: 9999;
    transform: translate(-50%, -50%);
    transition: transform 0.08s;
    mix-blend-mode: difference;
  }
  

  /* Scrollbar */
  ::-webkit-scrollbar { width: 4px; }
  ::-webkit-scrollbar-track { background: #050505; }
  ::-webkit-scrollbar-thumb { background: #D4AF37; border-radius: 2px; }
`;

function App() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);
  
  const handleBookTestRide = (formData) => {
    console.log("Test Ride Booking:", formData);
    // Here you can add API call or email sending logic
  };

  return (
    <>
      <style>{globalStyles}</style>

      {/* Custom cursor */}
      <div className="cursor-dot" id="cursorDot" />
      <div className="cursor-ring" id="cursorRing" />

      <script dangerouslySetInnerHTML={{
        __html: `
          const dot = document.getElementById('cursorDot');
          const ring = document.getElementById('cursorRing');
          if (dot && ring) {
            document.addEventListener('mousemove', e => {
              dot.style.left = e.clientX + 'px';
              dot.style.top = e.clientY + 'px';
              setTimeout(() => {
                ring.style.left = e.clientX + 'px';
                ring.style.top = e.clientY + 'px';
              }, 80);
            });
          }
        `
      }} />

      <TestRideModal 
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onSubmit={handleBookTestRide}
      />

      <Navbar onOpenModal={handleOpenModal} />
      <main>
        <Home onOpenModal={handleOpenModal} />
        <About onOpenModal={handleOpenModal} />
        <Services onOpenModal={handleOpenModal} />
        <HappyCostomer onOpenModal={handleOpenModal} />
        <Contact onOpenModal={handleOpenModal} />
        <Footer onOpenModal={handleOpenModal} />
      </main>
    </>
  );
}

export default App;